import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { useForm } from '@/form/useForm.ts';

export const NameSummaryFormPL = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['name'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const firstNameField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'firstname'),
    message: s.dataSummary.requiredMessage!,
  });
  const firstNameLabel = translate(firstNameField?.label);

  const genderField = s.name.fields.find(({ name }) => name === 'gender');
  const genderLabel = translate(genderField?.label);

  const lastNameField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'lastname'),
    message: s.dataSummary.requiredMessage!,
  });
  const lastNameLabel = translate(lastNameField?.label);

  const salutationField = s.name.fields.find(({ name }) => name === 'salutation');
  const salutationLabel = translate(salutationField?.label);
  const salutationValue =
    translate(salutationField?.options?.find(({ value }) => value === getFieldValue('salutation'))?.label) ||
    getFieldValue('salutation');

  const placeOfBirthField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'placeOfBirth'),
    message: s.dataSummary.requiredMessage!,
  });
  const placeOfBirthLabel = translate(placeOfBirthField?.label);

  const peselField = addReqiredMessage({
    field: s.peselCheck.fields.find(({ name }) => name === 'pesel'),
    message: s.dataSummary.requiredMessage!,
  });
  const peselLabel = translate(peselField?.label);

  return (
    <div className="summary-card" data-cy={'summary-form-name'}>
      <h2>{translate(s.dataSummary.titles?.name)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{salutationLabel}</div>
        <div className={'value'}>
          {!editMode && salutationValue}
          {editMode && <EditDataField field={salutationField!} slideId={'name'} />}
        </div>

        <div className={'label'}>{genderLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('gender')}
          {editMode && <EditDataField field={genderField!} slideId={'name'} />}
        </div>

        <div className={'label'}>{firstNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('firstname')}
          {editMode && <EditDataField field={firstNameField!} slideId={'name'} />}
        </div>

        <div className={'label'}>{lastNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('lastname')}
          {editMode && <EditDataField field={lastNameField!} slideId={'name'} />}
        </div>

        <div className={'label'}>{placeOfBirthLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('placeOfBirth')}
          {editMode && <EditDataField field={placeOfBirthField!} slideId={'name'} />}
        </div>

        <div className={'label'}>{peselLabel}</div>
        <div className={'value'}>{getFieldValue('pesel')}</div>
      </div>
    </div>
  );
};
